import { render, staticRenderFns } from "./SyaratDaftar.vue?vue&type=template&id=0bc6a2a5"
import script from "./SyaratDaftar.vue?vue&type=script&lang=js"
export * from "./SyaratDaftar.vue?vue&type=script&lang=js"
import style0 from "./SyaratDaftar.vue?vue&type=style&index=0&id=0bc6a2a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_webpack@5.89.0__lodash@4.17.21_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports